// The combined config for you environment will be available in the CONFIG global in your Javascript
module.exports = {
  supportTicketApi: 'https://ticket.prohub.test-godaddy.com/api/v1/tickets',
  godaddyProDomain: 'pro.test-godaddy.com',
  optinApi: 'https://optin.pcx.test-godaddy.com/api',
  optOutRedirect: 'https://account.test-godaddy.com/products?go_redirect=disabled&pro_opt_out=true',
  proApi: 'https://api.prohub.test-godaddy.com/api/v1',
  hubUrl: 'https://hub.test-godaddy.com',
  expertsApi: 'https://api.experts.test-godaddy.com/v1'
};
